import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./motoristas.component.html')
})
export class MotoristasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/motoristas.component.ts
 **/